export default __webpack_public_path__ + "static/media/1285.d919cad9.png";